<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Get KeyStore Information</h3>
    <p class="text-caption mb-4">Consultá la información de un keystore habilitado.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="validate"
      >Keystore Info >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-select
            v-model="keystoreId"
            :items="keyStoreIds"
            @update:modelValue="updateRequest"
            label="Keystore Id"
            item-title="id"
            item-value="id"
            required
        ></v-select>
      </v-col>
      <v-col md="6">
        <v-textarea
            name="parameters"
            label="Parameters"
            no-resize
            height="150px"
            v-model="requestPayload"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.response> </vue-json-pretty>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    props:['keyStoreIds'],
    components: {
      VueJsonPretty,
    },
    data: () => ({
      response: null,
      keystoreId: null,
      requestPayload: '{}',
      valid: true,
    }),
    watch: {
      lastKeystoreId(){
        this.keystoreId = lastKeystoreId;
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(){
        this.requestPayload = JSON.stringify({id:this.keystoreId},null, "\t")
      },
      validate () {
        console.log("validate ref:", this.$refs)
        if (this.$refs.form.validate()) {
          this.getKeyStoreInfo()
        }
      },
      getKeyStoreInfo() {
        console.log('this.requestPayload:', this.requestPayload);
          alisonJS.keyStoreInfo(JSON.parse(this.requestPayload)).then((info) => {
            this.response = info;
              this.setColor('success')
              this.setSnack('KeyStore info obtained successfully')
              this.$emit('enableTab', ['Generate CSR'])
              this.$emit('enableTab', ['Generate Certificate'])
              this.$emit('enableTab', ['Install Certificate'])
              this.$emit('setKeyStoreId',this.keystoreId);
              var concatProfiles = []
              info.keyStores.forEach(ks => {
                  concatProfiles = concatProfiles.concat(ks.profiles)
                });
              this.$emit('setKeyStoreInfo',concatProfiles);
          }).catch(e=>{
            console.log('error:', e);
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e
          })
      }
    },
  }
</script>
